import clsx from 'clsx'
import styles from './count.module.css'

export type CountProps = {
  value: number,
  variant?: 'primary' | 'secondary'
}

export const Count = ({value, variant, ...props}: CountProps) => <span className={clsx(styles.count, variant && styles[variant])} {...props}>{value}</span>
